export default __webpack_public_path__ + "static/media/Ubuntu-Regular.1cbb1b79.ttf";